import { render } from "./SessionListComponent.vue?vue&type=template&id=4ac38f47&scoped=true"
import script from "./SessionListComponent.vue?vue&type=script&lang=js"
export * from "./SessionListComponent.vue?vue&type=script&lang=js"

import "./SessionListComponent.vue?vue&type=style&index=0&id=4ac38f47&scoped=true&lang=scss"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac38f47"]])

export default __exports__